import { Controller } from "stimulus";
export default class extends Controller {
  jumpToPage(e) {
    e.preventDefault()
    window.location = e.target.value 
  }
}